// extracted by mini-css-extract-plugin
export default {"text":"TermsAndConditions_text__olona","title":"TermsAndConditions_title__LoZC0"};